class DclassoController {
    constructor() {

        this.setAboutLogo();
        this.setAboutLogoReno();
        this.setSpSlider();
    }

    setAboutLogo() {

        if($('.d-classo-content__about-logo-sticky').length < 1) {

            return;
        }
        let controller = new ScrollMagic.Controller();
        // window.scrollController.push(controller);
        let scene = new ScrollMagic.Scene({
            triggerElement: '.d-classo-content__r1',
            triggerHook: 'onEnter',
            reverse: true,
            offset: 360,
        })
            //.addIndicators({name: '____HRERE333'}) // add indicators (requires plugin)
            .addTo(controller);
        scene.on('enter', () => {
            $('.d-classo-content__about-logo-sticky').addClass('is-hide');
        });
        scene.on('leave', () => {
            $('.d-classo-content__about-logo-sticky').removeClass('is-hide');
        });
    }

    setAboutLogoReno() {
        if($('.renohouse-content__about-logo-sticky').length < 1) {

            return;
        }
        let controller = new ScrollMagic.Controller();
        // window.scrollController.push(controller);
        let scene = new ScrollMagic.Scene({
            triggerElement: '.renohouse-content__promise',
            triggerHook: 'onEnter',
            reverse: true,
            offset: 360,
        })
            //.addIndicators({name: '____HRERE333'}) // add indicators (requires plugin)
            .addTo(controller);
        scene.on('enter', () => {
            $('.renohouse-content__about-logo-sticky').addClass('is-hide');
        });
        scene.on('leave', () => {
            $('.renohouse-content__about-logo-sticky').removeClass('is-hide');
        });
    }

    setSpSlider() {
        let $items = $('.d-classo-content__other-items .swiper-slide').clone(false, false);
        $('#js-d-classo-content__other-spslider .swiper-wrapper').append($items);

        let options = {
            loop: false,
            // loopAdditionalSlides: 3,
            // loopedSlides: 5,
            // freeMode: true,
            // autoplay: {
            //     delay: 5000,
            //     disableOnInteraction: false,
            // },
            // loopFillGroupWithBlank: false,
            // updateOnWindowResize: false,
            // width: (window.UA.isSP)? 210: 420,
            centeredSlides: false,
            // centerInsufficientSlides: true,
            // width: (this.UA.isSP)? 190: 190,
            spaceBetween: window.UA.isSP ? 20 : 40,
            slidesPerView: 'auto',
            // slidesPerGroup: 1,
            navigation: {
                nextEl: '#js-d-classo-content__other-spslider-next',
                prevEl: '#js-d-classo-content__other-spslider-prev',
            },
            // scrollbar: {
            //     el: '#js-home-voice__slider-bar',
            //     // hide: true,
            //     draggable: false,
            // },
            touchAngle: 20,
            speed: 800,
            // pagination: {
            // el: '#js-mainvisual__slider-pagination',
            // clickable: true,
            // renderBullet: function (index, className) {
            //     return `<div class="mainvisual__slider-pagination-bullet"><svg width="44" height="44"><circle cx="22" cy="22" r="21" /></svg><span>0${(index + 1)}</span></div>`;
            // },
            // bulletClass: 'mainvisual__slider-pagination-bullet',
            // bulletActiveClass: 'is-active'
            // },
            // effect: 'fade',
            // fadeEffect: {
            //     crossFade: true
            // },
            on: {
                // onSlideChangeEnd : (s) => {s.fixLoop();}
            },
        };
        let otherSlider = new Swiper(
            '#js-d-classo-content__other-spslider',
            options
        );
        if (window.UA.isSP) {
            otherSlider.off('resize');
        }
    }
}

export default DclassoController;
